import { render, staticRenderFns } from "./controlElectricalPanels.vue?vue&type=template&id=7b4fc179"
import script from "./controlElectricalPanels.vue?vue&type=script&lang=js"
export * from "./controlElectricalPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports